<template>
  <div class="row min-h-screen shadow-none">
    <div class="col-lg-12">
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <ManagementTabs
          :activeTabProp="activeSubTab"
          :showManualUserDropdown="showManualUserDropdown"
          :showManualRoleDropdown="showManualRoleDropdown"
          :hasPermission="hasPermission"
          :refreshUsers="refreshUsers"
          @switchTab="switchSubTab"
          @toggleManualUserDropdown="toggleManualUserDropdown"
          @toggleManualRoleDropdown="toggleManualRoleDropdown"
          @viewFilter="viewFilter"
          @viewAdd="viewAdd"
          @viewSales="viewSales"
          @viewAddSalesManual="viewAddSalesManual"
          @viewAddManual="viewAddManual"
          @viewAddRoleManual="viewAddRoleManual"
          @viewAddBusinessRole="viewAddBusinessRole"
        />
        <div v-if="activeSubTab === 'user'">
          <UserTable
            :users="users"
            :modalUser="modalUser"
            :viewRemove="viewRemove"
            :viewResend="viewResend"
            :viewEditUser="viewEditUser"
            :pageSize="pageSize"
            :pageCount="pageCount"
            :pageNumber="pageNumber"
            :count="count"
            :changePage="gotoPage"
            :changeLimit="changeLimit"
            :loading="loading"
          />
        </div>
        <div v-if="activeSubTab === 'role'">
          <RoleTable v-if="user.type != 'Distributor'" />
          <DistRole v-if="user.type == 'Distributor'" />
        </div>
      </div>
    </div>
    <invite-user
      :roles="roles"
      :branches="Branches"
      @onInviteComplete="onInviteCompleteHandler"
    />
    <InviteSalesUser
      :count="count"
      @onInviteComplete="onInviteCompleteHandlers"
    />
    <edit-user
      :roles="roles"
      :branches="Branches"
      :uData="modalUserData"
    ></edit-user>

    <create-user @onCreateUserComplete="handleCreateUserComplete" />
    <create-sales-user @onCreateUser="handleCreateUserSalesComplete" />

    <!-- new modal for editing user -->

    <!-- modal for filters -->

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-edit"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header modal-header-colored">
            <h4 class="modal-title p-1">
              <b>Edit role for user:</b>
              {{
                editingUser.displayName
                  ? editingUser.displayName
                  : editingUser.emailAddress
                  ? editingUser.emailAddress
                  : editingUser.phoneNumber
              }}
            </h4>
            <button
              class="close md-close"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label class="col-12 col-sm-3 col-form-label text-sm-right"
                >Role</label
              >
              <div
                v-if="user.type == 'Distributor' || user.type == 'Manufacturer'"
                class="col-12 col-sm-8 col-lg-8"
              >
                <select
                  class="form-control"
                  placeholder="Select an option"
                  v-model="editingUser.role"
                >
                  <option v-for="r in roles" :key="r.id" :value="r.id">
                    {{ r.text }}
                  </option>
                </select>
                <ul v-if="v2.role" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
              <div v-else class="col-12 col-sm-8 col-lg-8">
                <select
                  class="form-control"
                  placeholder="Select an option"
                  v-model="editingUser.role"
                >
                  <option value="Administrator">Administrator</option>
                </select>
                <ul v-if="v2.role" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="width: 100px"
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              style="width: 100px"
              :disabled="isBusyModal"
              class="btn btn-primary"
              type="button"
              @click.prevent="updateRole"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mod-delete" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Confirmation
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div>
              <p class="text-[#353535] text-[16px] font-normal leading-[20px]">
                Are you sure you want to
                {{ modalUser.status == "Inactive" ? "enable" : "disable" }} this
                user:
                <strong>{{
                  modalUser.displayName
                    ? modalUser.displayName
                    : modalUser.emailAddress
                }}</strong
                >?
              </p>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click.prevent="updateStatus"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Yes, proceed</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade colored-header colored-header-primary"
      id="mod-filter"
      role="dialog"
    >
      <div
        class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end"
      >
        <div
          class="modal-content rounded-none bg-[#fff] py-[40px] px-[20px] md:px-[32px] h-[100dvh]"
        >
          <div class="modal-header- flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[18px] leading-[21.6px] capitalize text-[#353535] pb-[16px]"
            >
              Filter
            </h4>
            <button
              class="text-2xl text-[#353535] outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body p-0 m-0">
            <div class="pb-[24px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Status</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.status"
                >
                  <option value="0">All Users</option>
                  <option value="active">Active</option>
                  <option value="inactive">InActive</option>
                  <option value="pending">Others</option>
                </select>
              </div>
            </div>
            <div class="pb-[24px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Roles</label
              >
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  placeholder="Select an option"
                  v-model="filter.role"
                >
                  <option value="0">All Roles</option>
                  <option v-for="r in roles" :key="r.id" :value="r.text">
                    {{ r.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="pb-[24px]">
              <label
                class="text=[#353535] font-medium text-[14px] leading-[20px]"
                >Other filters</label
              >
              <div>
                <input
                  class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                  type="text"
                  placeholder="Filter by name, email..."
                  v-model="filter.qry"
                />
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-[#96A0B5] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              @click="reset"
            >
              Reset
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] rounded-[8px] text-white font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button"
              @click="getUsers"
            >
              {{ isBusyModal ? "Loading..." : "Search" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade py-1" id="mod-resend" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Resend Invite
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="">
              <p
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >
                You are about to resend an invite to this customer:
                <strong>{{ modalUser.emailAddress }}</strong
                >?
              </p>
            </div>
            <!-- <div v-if="enableInviteOption">
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              ></label>
              <div class="">
                <div
                  class="custom-control custom-radio"
                  :class="[{ 'is-invalid': v8.selectedOption }]"
                  v-for="option in inviteOptions"
                  :key="option.value"
                >
                  <input
                    type="radio"
                    :id="option.value"
                    name="customRadio"
                    class="custom-control-input"
                    :value="option.value"
                    v-model="selectedOption"
                  />
                  <label class="custom-control-label" :for="option.value">{{
                    option.name
                  }}</label>
                </div>
                <ul v-if="v8.selectedOption" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div> -->
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              :disabled="isBusyModal"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full disabled:cursor-not-allow"
              type="button"
              @click.prevent="attemptResendInvite"
            >
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Yes, proceed</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <GeneralDeleteCaution
      :id="DeleteId"
      @proceed="deleteUser"
      :isBusy="isBusyModal"
      text="user"
    />
    <GeneralDeleteMessage
      message="You cannot delete this user because they are 
      active or have transaction history. Consider disabling the user instead."
    />
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import SystemPermissions from "@/permissions";
import ManagementTabs from "../components/Management/ManagementTabs.vue";
import UserTable from "../components/Management/UserTable.vue";
import RoleTable from "../components/Management/RoleTable.vue";
import Select2 from "@/components/Select2";
import GeneralDeleteCaution from "../components/GeneralDeleteCaution.vue";
import GeneralDeleteMessage from "../components/GeneralDeleteMessage.vue";
import CreateUser from "../components/User/CreateUser.vue";
import InviteUser from "../components/User/InviteUser.vue";

import EditUser from "../components/User/EditUser";

import Pagination from "../components/Pagination.vue";
import CreateSalesUser from "../components/User/CreateSalesUser.vue";
import SalesRole from "../components/User/SalesRole.vue";
import BusinessRole from "../components/User/BusinessRole.vue";
import InviteSalesUser from "../components/User/InviteSalesUser.vue";
import { bus } from "../main";
import DistRole from "../components/Management/DistRole.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "UserManagement",
  components: {
    Select2,
    ManagementTabs,
    UserTable,
    RoleTable,
    CreateUser,
    EditUser,
    CreateSalesUser,
    InviteUser,
    GeneralDeleteCaution,
    GeneralDeleteMessage,
    Pagination,
    SalesRole,
    BusinessRole,
    InviteSalesUser,
    DistRole,
  },

  data() {
    return {
      count: 0,
      filter: {
        status: "0",
        role: "0",
        qry: "",
      },
      modalUserData: {},
      loading: true,
      showDropdown: null,
      showDropdownRole: null,
      showManualUserDropdown: false,
      showManualRoleDropdown: false,
      isBusy: false,
      isBusyModal: false,
      activeSubTab: null,
      createUser: {
        username: null,
        password: null,
        phoneNumber: null,
        emailAddress: null,
        name: null,
        role: null,
        branch: null,
        staffId: null,
        salesAccessId: null,
      },

      editingUser: {
        emailAddress: null,
        phoneNumber: null,
        displayName: null,
        role: null,
        branchId: null,
      },

      modalUser: {
        emailAddress: null,
        displayName: null,
      },

      Branches: [],
      v2: {
        role: false,
      },

      v3: {
        branch: false,
      },

      v5: {
        name: false,
      },
      v6: {
        email: false,
      },
      v7: {
        phone: false,
      },
      users: [],
      roles: [],
      DeleteId: "",
      count: 0,
      page: 0,
      pageNumber: 1,
      pageSize: 10,
      pageCount: 0,
      hasNext: false,
      hasPrev: false,

      v8: {
        selectedOption: false,
      },

      selectedOption: "",
    };
  },
  created() {
    if (!this.hasPermission("User_View") || !this.hasPermission("Role_View")) {
      this.$router.push("/restricted");
    }
    if (this.hasPermission("User_View")) {
      this.activeSubTab = "user";
    } else if (this.hasPermission("Role_View")) {
      this.activeSubTab = "role";
    } else {
      this.activeSubTab = null;
    }
    this.getUsers();
    this.getRoles();
    this.getBranches();
    bus.$on("getroles", this.getRoles);
    bus.$on("getroles", () => {
      // console.log("event received");
    });
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },

    enableInviteOption: function() {
      return this.modalUser.emailAddress && this.modalUser.phoneNumber;
    },
  },
  methods: {
    refreshUsers() {
      this.getUsers();
      bus.$emit("getroles");
      bus.$emit("getsales");
    },
    toggleDropdown(userId) {
      if (this.showDropdown === userId) {
        this.showDropdown = null;
      } else {
        this.showDropdown = userId;
      }
    },
    toggleDropdownRole(roleId) {
      if (this.showDropdownRole === roleId) {
        this.showDropdownRole = null;
      } else {
        this.showDropdownRole = roleId;
      }
    },
    toggleManualUserDropdown() {
      this.showManualUserDropdown = !this.showManualUserDropdown;
    },
    toggleManualRoleDropdown() {
      this.showManualRoleDropdown = !this.showManualRoleDropdown;
    },
    switchSubTab(subTab) {
      this.activeSubTab = subTab;
    },
    reset() {
      this.pageNumber = 1;
      this.filter = {
        status: "0",
        role: "0",
        qry: "",
      };
    },
    confirmDelete(id) {
      this.DeleteId = this.modalUser.id;
      id = this.DeleteId;

      $("#mod-confirm-delete").modal("show");
    },

    showDeleteMsg() {
      $("#mod-delete-msg").modal("show");
    },

    cancelConfirm() {
      this.DeleteId = "";
      $("#mod-confirm-delete").modal("hide");
    },
    async deleteUser() {
      this.isBusyModal = true;
      // try {
      //   const res = await this.$http.delete(
      //     `/Users/deleteUser/${this.DeleteId}`
      //   );
      //   if (res.ok) {
      //     this.$toast.success("User deleted successfully", {
      //       icon: true,
      //       rtl: false,
      //     });
      //     this.getUsers();
      //     this.cancelConfirm();
      //   }
      // } catch (error) {
      //   this.cancelConfirm();
      //   this.showDeleteMsg();
      // }
      this.isBusyModal = false;
    },

    viewAdd() {
      $("#mod-add").modal("show");
    },
    viewSales() {
      this.count = this.count + 1;
      $("#mod-sales").modal("show");
    },
    viewEditUser(data) {
      $("#mod-edit-user").modal("show");
      this.modalUserData = data;
    },

    viewAddManual() {
      $("#mod-add-manual").modal("show");
      this.showManualUserDropdown = false;
    },
    viewAddSalesManual() {
      $("#mod-add-manual-sales").modal("show");
      this.showManualUserDropdown = false;
    },

    // sales role toogle button
    viewAddRoleManual() {
      $("#mod-add-role").modal("show");
      this.showManualRoleDropdown = false;
    },

    // business role toggle button
    viewAddBusinessRole() {
      $("#mod-add-sales").modal("show");
      this.showManualRoleDropdown = false;
    },

    viewEdit(u) {
      this.editingUser = u;
      $("#mod-edit").modal("show");
    },

    viewEditBranch(u) {
      this.editingUser = u;
      $("#mod-edit-branch").modal("show");
    },

    viewEditName(u) {
      this.editingUser = u;
      $("#mod-edit-name").modal("show");
    },

    viewEditPhone(u) {
      this.editingUser = u;
      $("#mod-edit-phone").modal("show");
    },

    viewEditEmail(u) {
      this.editingUser = u;
      $("#mod-edit-email").modal("show");
    },

    viewRemove(u) {
      this.modalUser = u;
      $("#mod-delete").modal("show");
    },
    async updateStatus(id) {
      this.isBusyModal = true;
      try {
        let userType =
          this.modalUser.userType === "Office"
            ? "business"
            : this.modalUser.userType === "SalesForce"
            ? "sales"
            : "default";
        let url =
          userType === "business"
            ? `/Users/updateStatus/${this.modalUser.id}`
            : userType === "sales"
            ? `/SalesUsers/updateStatus/${this.modalUser.id}`
            : `/Users/updateStatus/${this.modalUser.id}`;
        let stats = this.modalUser.status;
        let reversStata = stats == "Active" ? "InActive" : "Active";
        let finalStat = this.modalUser.displayName
          ? reversStata
          : stats == "Inactive"
          ? "Pending"
          : "Inactive";
        const response = await this.$http.put(url, {
          status: finalStat,
          id: this.modalUser.id,
        });
        const data = await response.json();
        if (response) {
          this.isBusyModal = false;
          $("#mod-delete").modal("hide");
          this.$toast.success("Status Updated successfully", {
            icon: true,
            rtl: false,
          });
          this.getUsers();
        }
      } catch (err) {
        this.isBusyModal = false;
        $("#mod-delete").modal("hide");
        this.$toast.error("Status Updated failed", {
          icon: true,
          rtl: false,
        });
      }
    },
    viewFilter() {
      this.pageNumber = 1;
      $("#mod-filter").modal("show");
    },

    handleCreateUserComplete() {
      $("#mod-add-manual").modal("hide");
      this.getUsers();
    },
    handleCreateUserSalesComplete() {
      $("mod-add-manual-sales").modal("hide");
      this.getUsers();
    },
    viewResend(u) {
      this.modalUser = u;
      $("#mod-resend").modal("show");
    },
    onInviteCompleteHandler() {
      $("#mod-add").modal("hide");
      this.getUsers();
    },
    onInviteCompleteHandlers() {
      $("#mod-sales").modal("hide");
      this.getUsers();
    },
    async attemptResendInvite() {
      this.resendInvite();
    },

    async resendInvite() {
      this.isBusyModal = true;
      $("#mod-resend").modal("hide");

      try {
        let userType =
          this.modalUser.userType === "Office"
            ? "business"
            : this.modalUser.userType === "SalesForce"
            ? "sales"
            : "default";
        let url =
          userType === "business"
            ? `/Users/resendInvite/${this.modalUser.id}`
            : userType === "sales"
            ? `/SalesUsers/resendInvite/${this.modalUser.id}`
            : `/Users/resendInvite/${this.modalUser.id}`;

        const response = await this.$http.get(
          url + "?type=" + this.selectedOption
        );
        this.isBusyModal = false;
        if (response && response.ok) {
          this.$toast.success("Invite sent successfully.", {
            icon: false,
            rtl: false,
          });
        }
      } catch (err) {
        this.isBusyModal = false;
      }
    },
    validateResendInvite() {
      this.v8 = {
        selectedOption: false,
      };

      let isValid = true;

      if (!this.selectedOption) {
        this.v8.selectedOption = true;
        isValid = false;
      }

      return isValid;
    },

    updateRole() {
      this.isBusyModal = true;
      this.isBusy = true;

      let data = {
        id: this.editingUser.id,
        role: this.editingUser.role,
      };

      if (this.validateUpdateRole()) {
        $("#mod-edit").modal("hide");

        this.$http
          .put("/Users/updateRole/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
            this.getUsers();
          })
          .catch(function() {
            this.isBusy = false;
            this.isBusyModal = false;
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },

    validateUpdateRole() {
      this.v2 = {
        role: false,
      };
      let isValid = true;

      if (!this.editingUser.role) {
        this.v2.role = true;
        isValid = false;
      }
      return isValid;
    },

    updateBranch() {
      this.isBusyModal = true;
      this.isBusy = true;

      let data = {
        id: this.editingUser.id,
        branchId: this.editingUser.branchId,
      };

      if (this.validateUpdateBranch()) {
        $("#mod-edit-branch").modal("hide");

        this.$http
          .put("/Users/updateBranch/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
            this.getUsers();
          })
          .catch(function() {
            this.isBusy = false;
            this.isBusyModal = false;
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },

    validateUpdateBranch() {
      this.v3 = {
        branch: false,
      };
      let isValid = true;

      if (!this.editingUser.branchId) {
        this.v3.branch = true;
        isValid = false;
      }
      return isValid;
    },

    updateName() {
      this.isBusyModal = true;
      this.isBusy = true;

      let data = {
        id: this.editingUser.id,
        displayName: this.editingUser.displayName,
      };

      if (this.validateUpdateName()) {
        $("#mod-edit-name").modal("hide");

        this.$http
          .put("/Users/updateName/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
            this.getUsers();
          })
          .catch(function() {
            this.isBusy = false;
            this.isBusyModal = false;
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },

    validateUpdateName() {
      this.v5 = {
        name: false,
      };
      let isValid = true;

      if (!this.editingUser.displayName) {
        this.v5.name = true;
        isValid = false;
      }
      return isValid;
    },

    updateEmail() {
      this.isBusyModal = true;
      this.isBusy = true;

      let data = {
        id: this.editingUser.id,
        emailAddress: this.editingUser.emailAddress,
      };

      if (this.validateUpdateEmail()) {
        $("#mod-edit-email").modal("hide");

        this.$http
          .put("/Users/updateEmail/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
            this.getUsers();
          })
          .catch(function() {
            this.isBusy = false;
            this.isBusyModal = false;
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },

    validateUpdateEmail() {
      this.v6 = {
        email: false,
      };
      let isValid = true;

      if (!this.editingUser.emailAddress) {
        this.v6.email = true;
        isValid = false;
      }
      return isValid;
    },

    updatePhone() {
      this.isBusyModal = true;
      this.isBusy = true;

      let data = {
        id: this.editingUser.id,
        phoneNumber: this.editingUser.phoneNumber,
      };

      if (this.validateUpdatePhone()) {
        $("#mod-edit-phone").modal("hide");

        this.$http
          .put("/Users/updatePhoneNumber/" + data.id, data)
          .then(function(res) {
            this.isBusyModal = false;
            this.getUsers();
          })
          .catch(function() {
            this.isBusy = false;
            this.isBusyModal = false;
          });
      } else {
        this.isBusy = false;
        this.isBusyModal = false;
      }
    },

    validateUpdatePhone() {
      this.v7 = {
        phone: false,
      };
      let isValid = true;

      if (!this.editingUser.phoneNumber) {
        this.v7.phone = true;
        isValid = false;
      }
      return isValid;
    },

    async getUsers() {
      this.isBusy = true;
      this.isBusyModal = true;
      if (this.filter.qry) {
        this.pageNumber = 1;
      }
      this.loading = true;
      let endpoint = "/Users/";
      let params =
        "pageSize=" +
        this.pageSize +
        (this.filter.status != "0" ? "&status=" + this.filter.status : "") +
        (this.filter.role != "0" ? "&role=" + this.filter.role : "") +
        (this.filter.qry != "" ? "&query=" + this.filter.qry : "") +
        (this.user.parentId ? "&parentId=" + this.user.parentId : "");
      const pageParam =
        this.user.type === "Manufacturer"
          ? "pageNumber=" + this.pageNumber
          : "page=" + (this.pageNumber - 1);
      endpoint +=
        this.user.type === "Manufacturer"
          ? "getAllEnterpriseUsers?" + pageParam + "&" + params
          : "getList?" + pageParam + "&" + params;
      try {
        const res = await this.$http.get(endpoint);
        this.users = res.body.data;
        if (this.user.type === "Manufacturer") {
          this.pageNumber = res.body.pageNumber;
        } else {
          this.pageNumber = (res.body.page || 0) + 1;
        }
        this.pageSize = res.body.pageSize;
        this.count = res.body.count;
        this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
        this.hasPrev = res.body.hasPrev;
        this.hasNext = res.body.hasNext;
      } catch (err) {
        console.error(err);
      } finally {
        $("#mod-filter").modal("hide");
        this.isBusy = false;
        this.loading = false;
        this.isBusyModal = false;
      }
    },
    prev() {
      if (this.pageNumber > 1) {
        this.pageNumber -= 1;
        this.getUsers();
      }
    },
    next() {
      if (this.hasNext) {
        this.pageNumber += 1;
        this.getUsers();
      }
    },
    gotoPage(page) {
      if (page >= 1 && page <= this.pageCount) {
        this.pageNumber = page;
        this.getUsers();
      }
    },
    changeLimit(limit) {
      this.pageSize = limit;
      this.pageNumber = 1;
      this.getUsers();
    },
    async getRoles() {
      try {
        const res = await this.$http.get("/Roles/getAllEnterpriseRoles");
        if (res && res.body) {
          this.roles = res.body.map((v) => ({
            id: v.id,
            text: v.roleName,
          }));
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    },
    getBranches() {
      var a = true;

      this.$http
        .get(
          "/Branches/getListNoPaging?active=" +
            a +
            "&parentId=" +
            this.user.parentId
        )
        .then(function(res) {
          this.Branches = res.body;
        })
        .catch(function() {});
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
  },
};
</script>
<style scoped>
.active {
  background-color: #2463eb;
  color: white;
}
</style>
